<template>
  <div style="display:flex">
    <vs-button
        flat
        :active="currentServer === server.IframeURL"
        :class="{ active: (currentServer === server.IframeURL), flip: (flip) }"
        :key="server.id"
        @click="changeLink(index)"
        v-for="(server, index) in servers"
    >
      {{ server.ServerType }}
    </vs-button>
  </div>
</template>

<script>
export default {
  name: "ServerSelector",
  props: {
    servers: {
      type: Object
    },
    currentServer: {
      type: String
    },
    changeLink: {
      type: Function
    },
    flip: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.active {
  transform: translate(0, -5px);
  border-radius: 0 0 12px 12px;
}

.flip.active {
  transform: translate(0, 5px);
  border-radius: 12px 12px 0 0;
}
</style>
